"use strict";

Shopify.theme.jsMegaMenu = {
  init: function init($section) {
    // Add settings from schema to current object
    Shopify.theme.jsMegaMenu = $.extend(this, Shopify.theme.getSectionData($section)); // Selectors

    var parentLink = this.parent_link;
    var parentLinkMain = this.parent_link_main;
    var sectionId = this.section_id;
    var $megaMenu = $section.find(".mega-menu__" + sectionId);
    var $parentElement = $(
      '.header__menu [data-navlink-handle="' +
        parentLink +
        '"], .sticky-header__menu [data-navlink-handle="' +
        parentLink +
        '"]'
    );
    var $parentElementLink = $parentElement.children(".header__link"); // Remove old mega menus

    var mainMenu = $(
      `.mega-menu[data-parent-link-men="${parentLinkMain}"], .mega-menu[data-parent-link-women="${parentLinkMain}"]`
    );
    var $containerMainMenu = mainMenu.find(`[data-parent-link-item="${parentLink}"]`);

    $parentElement.find(".mega-menu__section").remove(); // Mobile Selectors

    var $parentMobileElement = $('[data-mobile-menu-navlink-handle="'.concat(parentLink, '"]'));
    /* No submenu is present - add mega menu elements and caret */

    if ($parentMobileElement.find(".has-no-submenu").length) {
      // Assign class to display dropdown arrow
      $parentMobileElement.find("a.mobile-menu__item").addClass("mobile-menu-link"); // Insert close icon after menu item

      $parentMobileElement.find("a").after('<span class="close-dropdown" aria-expanded="false"></span>'); // Insert placeholder ul for megamenu

      $parentMobileElement
        .find(".submenu__label")
        .after(
          '<ul class="mobile-submenu__list mobile-menu__submenu has-mega-menu" data-mobile-submenu-first-level-list></ul>'
        ); // Find data attribute for toggle and assign it true

      var $mobileMenuToggle = $parentMobileElement.find("[data-mobile-menu-has-toggle]");
      $($mobileMenuToggle).attr("data-mobile-menu-has-toggle", true); // Insert mega menu

      var $parentList = $parentMobileElement.find(".has-mega-menu");
      $megaMenu.clone().appendTo($parentList);
    } else {
      /* Submenu is present - add mega menu elements and remove current sub-menu */
      var _$parentList = $parentMobileElement.find("[data-mobile-submenu-first-level-list]");

      _$parentList.empty().addClass("has-mega-menu").removeClass("has-dropdown"); // Insert mega menu

      $megaMenu.clone().appendTo(_$parentList);
    } // Desktop

    if ($parentElement.hasClass("header__item") || $parentElement.hasClass("vertical-header__first-level")) {
      // Hide default dropdown
      $parentElement.find(".navbar-dropdown").addClass("is-invisible is-hidden"); // Add arrow to parent link to indicate dropdown

      $parentElementLink.removeClass("is-arrowless");
      $megaMenu
        .clone()
        .appendTo(
          '.vertical-header__first-level[data-navlink-handle="' +
            parentLink +
            '"], .header__item[data-navlink-handle="' +
            parentLink +
            '"]'
        ); // Add/remove classes for proper styling and append mega menu instance

      if ($containerMainMenu && $containerMainMenu.length > 0) {
        $megaMenu
          .find(`.mega-menu[data-parent-link=${parentLinkMain}] .container.has-no-side-gutter`)
          .clone()
          .appendTo($containerMainMenu);
      }

      $parentElement.addClass("has-mega-menu");
    }

    const links = document.querySelectorAll(".ignore-click");

    links.forEach((link) => {
      link.addEventListener("click", preventDefault);
    });

    function preventDefault(event) {
      event.preventDefault();
    }

    document.querySelectorAll(".icon-close-megamenu").forEach((link) => {
      link.addEventListener("click", function (e) {
        e.stopPropagation();
        e.preventDefault();
        $(".mega-menu__section").removeClass("is-active");
        $(".header__link").removeClass("link-active");
      });
    });
    
    const inputElement = document.getElementById("autocomplete-0-input");
    if (inputElement) {
      inputElement.addEventListener("input", function () {
        $(".mega-menu__section").removeClass("is-active");
        $(".header__link").removeClass("link-active");
      });
    }


    document.body.addEventListener("click", function (e) {
      const target = event.target;
      const isClickInside = document.querySelector(".header .header__inner-content").contains(target);

      if (!isClickInside) {
        $(".mega-menu__section").removeClass("is-active");
        $(".header__link").removeClass("link-active");
      }
    });

    document.querySelector("#search-button-head")?.addEventListener("click", function (e) {
      e.stopPropagation();
      e.preventDefault();
      $(".aa-DetachedSearchButton").click();
    });

    $(".navbar-item, .header__brand, .header__search").on("click", function () {
      //Close any mega menus on hover
      $(".mega-menu__section").removeClass("is-active");
      $(".header__link").removeClass("link-active");

      if ($(this).hasClass("has-mega-menu")) {
        //Toggle corresponding mega menu
        $(this).find(".mega-menu__section").addClass("is-active");
        $(this).find(".header__link").addClass("link-active");
      }
    });

    var timer;
    var delay = 50;

    $(".second-menu-item .header__link")
      .on("mouseenter", function () {
        var parent = $(this).parent();
        var $this = $(this);

        $this.children(".header__nav-sub-list").show();
        $this.addClass("is-open");

        // Close any mega menus on hover
        var headerLink = parent.find(".header__link");
        var megaSection = parent.find(".mega-menu__section");

        timer = setTimeout(function() {
          if (
            parent.hasClass("has-mega-menu") &&
            !headerLink.hasClass("link-active") &&
            !megaSection.hasClass("is-active")
          ) {
            $(".mega-menu__section").removeClass("is-active");
            $(".header__link").removeClass("link-active");

            // Toggle corresponding mega menu
            megaSection.addClass("is-active");
            headerLink.addClass("link-active");
          }
        }, delay);

        $('.aa-ClearButton').trigger('click')
      });

    $(".second-menu-item .header__link").on("mouseleave", function () {
      clearTimeout(timer)
    })

    $(".mega-menu").on("mouseleave", function(e) {
      var parent = $(this).closest(".has-mega-menu");
      var headerLink = parent.find(".header__link");
      var megaSection = parent.find(".mega-menu__section");
      
      if (e.relatedTarget.nodeName === "HEADER") {
        megaSection.removeClass('is-active');
        headerLink.removeClass('link-active');
      }
    })

    $(".second-menu-item").on("click", function () {
      var headerLink = $(this).find(".header__link");
      window.location.href = headerLink.attr("href");
    });
    
  },
  showThemeEditorState: function showThemeEditorState(id, $section) {
    $(".mega-menu__" + id + " .mega-menu").addClass("mega-menu--force-show");
    $(".mega-menu__" + id + " .mega-menu")
      .prev(".header__link")
      .addClass("is-active");
  },
  hideThemeEditorState: function hideThemeEditorState(id, $section) {
    $(".mega-menu__" + id + " .mega-menu").removeClass("mega-menu--force-show");
    $(".mega-menu__" + id + " .mega-menu")
      .prev(".header__link")
      .removeClass("is-active");
  },
  displayMenu: function displayMenu(id) {
    $(".mega-menu").removeClass("mega-menu--show");
    $(".mega-menu__" + id + " .mega-menu").addClass("mega-menu--show");
  },
  hideMenu: function hideMenu(id) {
    $(".mega-menu__" + id + " .mega-menu").removeClass("mega-menu--show");
    document.querySelectorAll(".submenu__input").forEach((x) => (x.checked = false));
  },
  unload: function unload($section) {
    var parentLink = $section.find(".mega-menu").data("parent-link");
    var navLink = $('[data-navlink-handle="' + parentLink + '"]');
    navLink.off();
    navLink.find(".mega-menu__section").remove();
    $(".mega-menu__section, .navbar, .navbar-item, .header__brand, .header__search").off();
  },
};

(function () {
  if (!Shopify.designMode) {
    var placeholderEl = document.getElementById("MegaMenuPlaceholder");

    if (!placeholderEl) {
      return;
    }

    fetch("/?view=mega-menu")
      .then(function (res) {
        return res.text();
      })
      .then(function (html) {
        placeholderEl.innerHTML = html;

        $(".shopify-section", placeholderEl).each(function () {
          Shopify.theme.jsMegaMenu.init($(this));
        });
      })
      .catch((err) => console.error(err));
  }
})();

// dropdown submenu
document.addEventListener("DOMContentLoaded", function(){
  $('.mobile-menu__submenu-list-item.mobile-menu__dropdown-button').each(function(index) {
    var $sibling = $(this).next()
    
    $(this).on('click', function(e) {
      e.preventDefault()
      $sibling.toggleClass('active')
      $(this).toggleClass('active')
    })
  })

  // force all submenus to be the same height
  function alignSubmenus() {
    $('.mobile-submenu__list').each(function() {
      console.log($('.mobile-menu__content').height())
      if ($('.mobile-menu__content').length && $('.mobile-menu__content').height())
        $(this).attr('style', `height:${$('.mobile-menu__content').height()}px`)
    })
  }
  alignSubmenus();
  window.addEventListener("resize", alignSubmenus)
})